// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__1PXjH","label":"PriceFilterPopup_label__o9RHa","labelSelected":"PriceFilterPopup_labelSelected__2522d"};